export default {
      id: "arrow-left-usage",
      viewBox: "0 0 38 13",
      url: "../../assets/" + "sprite.svg#arrow-left-usage",
      toString: function () {
        return this.url;
      }
    }